import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class InternalRating extends ModelBase {
    static typeName = "InternalRating";

    public internalRatingId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Internal Rating")
    public internalRatingName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.internalRatingName) {
            return "New internal rating";
        } else {
            return this.internalRatingName;
        }
    }
}